import React from 'react';
import { RESOURCE_TYPE_CREDENTIALS, RESOURCE_TYPE_SOURCE } from 'js/constants/resourceTypes';
import { ResourceCard } from './ResourceCard';
import './DataCard.css';

function DataSourceCard(props) {
  const { data } = props;

  const onItemClick = () => {
    if (props?.onItemClick) {
      props.onItemClick(RESOURCE_TYPE_SOURCE, props.data);
    }
  };

  return (
    <div className="datasource-card-container">
      <ResourceCard
        {...props}
        data={data}
        onClick={!!props?.onItemClick ? onItemClick : undefined}
        resourceType={RESOURCE_TYPE_SOURCE}
        status="normal"
      />
    </div>
  );
}

export default DataSourceCard;
